import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Integrations18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_603)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.1251 0.81441L7.93944 4.00002L8.9394 4.99998L7.46971 6.46966L8.53037 7.53032L10.0001 6.06064L11.9394 7.99998L10.4697 9.46966L11.5304 10.5303L13.0001 9.06064L14.0001 10.0607L17.1805 6.88037L17.1857 6.87502C17.6556 6.39561 17.6557 5.60441 17.1857 5.12499L15.5607 3.49997L17.5304 1.53032L16.4697 0.469662L14.5001 2.4393L12.8805 0.819661L12.8751 0.81441C12.3957 0.344476 11.6045 0.344476 11.1251 0.81441ZM10.0608 4.00002L12.0001 2.06068L15.9394 6.00002L14.0001 7.93936L10.0608 4.00002Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.10745 17.1681L3.5 15.5607L1.53037 17.5303L0.469713 16.4697L2.43934 14.5L0.814313 12.875C0.344384 12.3956 0.344422 11.6044 0.814339 11.125L0.81959 11.1196L3.99995 7.93933L10.0616 14.001L6.88245 17.1681L6.88049 17.1701C6.39841 17.654 5.59028 17.6537 5.10862 17.1693L5.10745 17.1681ZM2.06061 12L5.99528 15.9347L7.93828 13.999L3.99995 10.0606L2.06061 12Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_603'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Integrations18.displayName = 'Integrations18';
export default Integrations18;
